import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>Meet Your Coach</h2>
        <p>
          My name is Dr. Matt Townsend, and for the last 25 years, I’ve worked as a marriage educator & relationship coach. And in that time, I’ve helped thousands of couples learn to communicate effectively, and successfully resolve their toughest conflicts.
        </p>
        <p>
          I can confidently say, I know what it takes to turn a broken & damaged relationship, into a thriving one that stands the test of time.
        </p>
        <p>
          During our weekly group coaching sessions, I'm going to teach you real world, actionable skills & solutions that can be applied today, to start seeing improvements immediately.
        </p>

                <br />
        <br />
        <a
          href="https://g.co/kgs/5RXiR8x"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vist my Office
        </a>
      </Wrap>
    </>
  );
};

export default Content;
